export const
	ALWAYS_REGEX = /(?:)/u,
	ALWAYS_REGEX_G = new RegExp(ALWAYS_REGEX, "gu"),
	DISABLED_TOOLTIP = "",
	DOUBLE_ACTION_WAIT = 2,
	JSON_STRINGIFY_SPACE = "\t",
	NEVER_REGEX = /^\b$/u,
	NEVER_REGEX_G = new RegExp(NEVER_REGEX, "gu"),
	NOTICE_NO_TIMEOUT = 0,
	SI_PREFIX_SCALE = 1000

export namespace DOMClasses {
	export const
		ALLOW_FOLD_HEADINGS = "allow-fold-headings",
		ALLOW_FOLD_LISTS = "allow-fold-lists",
		IS_READABLE_LINE_WIDTH = "is-readable-line-width",
		MARKDOWN_PREVIEW_SECTION = "markdown-preview-section",
		MARKDOWN_PREVIEW_SIZER = "markdown-preview-sizer",
		MARKDOWN_PREVIEW_VIEW = "markdown-preview-view",
		MARKDOWN_RENDERED = "markdown-rendered",
		MOD_WARNING = "mod-warning",
		MODAL = "modal",
		MODAL_CLOSE_BUTTON = "modal-close-button",
		NODE_INSERT_EVENT = "node-insert-event",
		SETTING_ITEM = "setting-item",
		SHOW_INDENTATION_GUIDE = "show-indentation-guide",
		STATUS_BAR = "status-bar",
		VERTICAL_TAB_CONTENT = "vertical-tab-content",
		VERTICAL_TAB_CONTENT_CONTAINER = "vertical-tab-content-container"
}

export namespace FileExtensions {
	export const
		MARKDOWN = "md"
}

export namespace LibraryUUIDs {
	export const
		UUID0 = "2af98ef6-0537-4fd3-a1e1-269517bca44d",
		UUID1 = "fec54e0c-8342-4418-bc4b-57ea4d92c3d4",
		UUID2 = "387823d1-e81d-4ed2-8148-4023aeae81a6",
		UUID3 = "c4ba1170-c0b7-4fde-a4a5-047c74ea5298"
}
